/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 * Written by Hendrik, December 28, 2025.
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './dashboard.css';

// SVG Icons components for a cleaner look


const UsersIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
);

const ChartIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"></line>
        <line x1="12" y1="20" x2="12" y2="4"></line>
        <line x1="6" y1="20" x2="6" y2="14"></line>
    </svg>
);

const PendingIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
);

export default function Dashboard() {
    const [stats, setStats] = useState({ total_students: 0, average_mark: 0, pending_marking: 0 });
    const [loading, setLoading] = useState(true);
    const [upcomingEvent, setUpcomingEvent] = useState(null)

    useEffect(() => {
        const loadDashboard = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetch_dashboard.php`);
                setStats(response.data.stats || { total_students: 0, average_mark: 0, pending_marking: 0 });
            } catch (error) {
            } finally {
                setLoading(false);
            }
        };
        loadDashboard();
    }, []);

    useEffect(() => {
        // Fetch next upcoming event
        const fetchUpcoming = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/fetch_next_event.php`);
                if (res.data.success) {
                    setUpcomingEvent(res.data.event);
                }
            } catch (e) { }
        };
        fetchUpcoming();
    }, []);

    // Get current date for the header
    const today = new Date().toLocaleDateString('en-ZA', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

    // Get personalized greeting based on time of day
    const getGreeting = () => {
        const hour = new Date().getHours();
        const username = localStorage.getItem('username') || 'User';
        let greeting = '';

        if (hour < 12) {
            greeting = 'Good morning';
        } else if (hour < 17) {
            greeting = 'Good afternoon';
        } else {
            greeting = 'Good evening';
        }

        return `${greeting}, ${username}!`;
    };

    return (
        <div className='dash_main'>
            <header className="dash_header">
                <div>
                    <h1>{getGreeting()}</h1>
                    <p className="date_text">{today}</p>
                </div>
            </header>



            {loading ? (
                <div className="loading_state">Loading statistics...</div>
            ) : (
                <div className='card_container'>

                    {/* Card 1: Total Students */}
                    <div className='stat_card'>
                        <div className='icon_wrapper blue'>
                            <UsersIcon />
                        </div>
                        <div className='card_content'>
                            <h3>Total Students</h3>
                            <h4 className="stat_number">{stats.total_students}</h4>
                            <p className="stat_desc">Enrolled learners</p>
                        </div>
                    </div>

                    {/* Card 2: Average */}
                    <div className='stat_card'>
                        <div className='icon_wrapper green'>
                            <ChartIcon />
                        </div>
                        <div className='card_content'>
                            <h3>Overall Average</h3>
                            <h4 className="stat_number">{stats.average_marks}%</h4>
                            <p className="stat_desc">Across all subjects</p>
                        </div>
                    </div>

                    {/* Card 3: Pending */}
                    <div className='stat_card'>
                        <div className='icon_wrapper orange'>
                            <PendingIcon />
                        </div>
                        <div className='card_content'>
                            <h3>Pending Marking</h3>
                            <h4 className="stat_number">{stats.pending_marking}</h4>
                            <p className="stat_desc">Incomplete records</p>
                        </div>
                    </div>

                </div>
            )}
        </div>
    );
}